import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { MaintenanceRecord } from '../../../../types/api';
import { MaintenanceRecordCard } from './components/MaintenanceRecordCard';
import { useTranslation } from '../../../../i18n';

interface UpcomingMaintenanceListViewProps {
  maintenanceRecords: MaintenanceRecord[];
  loading: boolean;
  error?: string | null;
  onMaintenanceClick?: (maintenance: MaintenanceRecord) => void;
}

export const UpcomingMaintenanceListView: React.FC<UpcomingMaintenanceListViewProps> = ({
  maintenanceRecords,
  loading,
  error,
  onMaintenanceClick,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2} textAlign="center">
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  if (maintenanceRecords.length === 0) {
    return (
      <Box p={2} textAlign="center">
        <Typography variant="body2" color="text.secondary">
          {t('maintenanceTab.noUpcoming')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {maintenanceRecords.map((record) => (
        <MaintenanceRecordCard
          key={record.id}
          record={record}
          onClick={() => onMaintenanceClick?.(record)}
          showWorkOrderId={false}
        />
      ))}
    </Box>
  );
};
